const { REACT_APP_LOST_FOUND_URL, REACT_APP_LOST_FOUND_ACCESS_TOKEN } =
  process.env;

const maskedPhoneNumberApi = ({chnl_id}) => {
  return {
    headers: {
      username: "p90meg",
      emquest_access_token: REACT_APP_LOST_FOUND_ACCESS_TOKEN,
      chnl_id: chnl_id
    },
    apiUrl: REACT_APP_LOST_FOUND_URL + `/entry_customer_phone_number`,
  };
};

export default maskedPhoneNumberApi;
